import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// project imports
import { useEffect, useState } from 'react';
import { LOGOUT } from 'store/actions';

// third party
import axios from 'axios';
import api from 'api/axios';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const account = useSelector((state) => state.account);
    const { isLoggedIn } = account;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [tokenValid, setTokenValid] = useState(true);

    const checkSession = async (signal) => {
        try {
            const response = await api.post(
                'users/checkSession',
                {}, // Empty body if not needed
                {

                    signal
                }
            );
            return response?.data?.success ?? false;
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Session check canceled', error.message);
                return false; // Or whatever makes sense for your flow
            }
            return error.response?.status === 200; // Adjust based on your API's error response
        }
    };

    // Usage in useEffect
    useEffect(() => {
        let abortController;

        const verifySession = async () => {
            abortController = new AbortController();
            const isValid = await checkSession(abortController.signal);
            setTokenValid(isValid);
        };

        if (account?.token) {
            verifySession();
        }

        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, [account?.token]);  // Only depend on account.token

    // useEffect(() => {
    //     let abortController;
    //     (async () => {
    //         abortController = new AbortController();
    //         const signal = abortController.signal;

    //         await axios
    //             .post(
    //                 `${configData.apiServer}users/checkSession`,
    //                 {},
    //                 {
    //                     headers: { accept: 'application/json', Authorization: account.token }
    //                 },
    //                 { signal }
    //             )
    //             .then((response) => setTokenValid(response?.data.success))
    //             .catch((error) => setTokenValid(error.status));
    //     })();

    //     return () => abortController.abort();
    // }, [account]);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/', { replace: true });
        }

        if (!tokenValid) {
            navigate('/', { replace: true });
            dispatch({ type: LOGOUT });
        }
    }, [isLoggedIn, navigate, tokenValid, dispatch]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
